import { z } from "zod";

import { Currency } from "hakikat/utils";

import { ProductSummarySchema } from "./product.model";
import { ContactSchema } from "./contact.model";

export enum Channel {
  REPRESENTATIVE = "representative",
  WEB = "web"
};

export enum OrderStatus {
  CANCELLED = 'cancelled',
  COMPLETED = 'completed',
  PENDING = 'pending',
  PROCESSING = 'processing'
};

export enum OrderPaymentStatus {
  PAID = 'paid',
  PENDING = 'pending',
  REFUNDED = 'refunded'
};

export type OrderItem = z.infer<typeof OrderItemSchema>;
export const OrderItemSchema = z.object({
  id: z.string(),
  oid: z.string(),
  
  did: z.string().optional(),

  pid: z.string(),
  price: z.number().positive("Price must be positive.").min(0.01, "Price must be at least 0.01."),
  quantity: z.number().positive("Quantity must be positive.").min(1, "Quantity must be at least 1."),

  contact: ContactSchema.optional(),
  attributes: z.record(z.string(), z.any()).optional(),

  note: z.string().optional(),
  summary: ProductSummarySchema,

  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type Order = z.infer<typeof OrderSchema>;
export const OrderSchema = z.object({
  id: z.string(),
  uid: z.string(),

  channel: z.nativeEnum(Channel),
  contact: ContactSchema,

  note: z.string().optional(),
  itemCount: z.number().positive("Item count must be positive.").min(1, "Item count must be at least 1."),

  amount: z.number().positive("Price must be positive.").min(0.01, "Price must be at least 0.01."),
  currency: z.nativeEnum(Currency),

  orderStatus: z.nativeEnum(OrderStatus),
  paymentStatus: z.nativeEnum(OrderPaymentStatus),

  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type OrderDetails = z.infer<typeof OrderDetailsSchema>;
export const OrderDetailsSchema = OrderSchema.extend({
  items: z.array(OrderItemSchema)
});

export type OrderCreateResponse = z.infer<typeof OrderCreateResponseSchema>;
export const OrderCreateResponseSchema = z.object({
  id: z.string()
});

export type OrderUpdateResponse = z.infer<typeof OrderUpdateResponseSchema>;
export const OrderUpdateResponseSchema = z.object({
  id: z.string()
});

export type OrderDeleteResponse = z.infer<typeof OrderDeleteResponseSchema>;
export const OrderDeleteResponseSchema = z.object({
  id: z.string()
});

//#region Order Item Models
export type ItemAttributesUpdateResponse = z.infer<typeof ItemAttributesUpdateResponseSchema>;
export const ItemAttributesUpdateResponseSchema = z.object({
  id: z.string()
});
//#endregion